import { Storage } from '@ionic/storage-angular';

export function provideStorage(): any[] {
  const storage = new Storage();
  const initPromise = storage.create();

  return [
    { provide: Storage, useValue: storage },
    { provide: 'STORAGE_INIT', useValue: initPromise },
  ];
}
